import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

const API_URL = '/cargo/api/admin/analytics';

export interface AnalyticsKpiValues {
  visitors: number;
  visits: number;
  pageviews: number;
  avgDurationSec: number;
  bounceRate: number;
  registrations: number;
}

export interface AnalyticsSummary {
  kpi: AnalyticsKpiValues & { prev: AnalyticsKpiValues };
  series: { unit: 'hour' | 'day'; points: { t: string; visitors: number }[] };
  pages: { path: string; views: number; visitors: number; avgDurationSec: number }[];
  cities: { city: string; country: string | null; visitors: number }[];
  sources: { source: string; visitors: number }[];
  campaigns: { utmSource: string | null; utmCampaign: string | null; visitors: number }[];
  devices: { type: string; visitors: number }[];
  browsers: { name: string; visitors: number }[];
  languages: { code: string; visitors: number }[];
}

export interface AnalyticsVisit {
  /** ISO со смещением Астаны (+05:00) */
  startedAt: string;
  city: string | null;
  country: string | null;
  deviceType: string;
  browser: string | null;
  source: string;
  entryPath: string;
  pages: number;
  durationSec: number | null;
  userId: number | null;
}

export interface AnalyticsVisitsPage {
  content: AnalyticsVisit[];
  totalElements: number;
  totalPages: number;
  currentPage: number;
  pageSize: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

/** API вкладки «Статистика посетителей» (только ROLE_ADMIN). Даты — дни по времени Астаны, включительно. */
@Injectable({ providedIn: 'root' })
export class AdminAnalyticsService {
  constructor(private http: HttpClient) {}

  getSummary(from: string, to: string): Observable<AnalyticsSummary> {
    const params = new HttpParams().set('from', from).set('to', to);
    return this.http.get<AnalyticsSummary>(`${API_URL}/summary`, { params });
  }

  getVisits(page: number, size: number): Observable<AnalyticsVisitsPage> {
    const params = new HttpParams().set('page', page).set('size', size);
    return this.http.get<AnalyticsVisitsPage>(`${API_URL}/visits`, { params });
  }
}
